import * as Yup from "yup";

export const UserFormValidation = Yup.object({
    userStatusId: Yup.string()
        .required("Status is required"),
});
